<template>
  <v-navigation-drawer v-model="drawerRight"
                        app
                        clipped
                        right>
                
    <v-list dense
            class="ma-auto"
            align="center">
      <template v-for="(item, i) in items">
        <v-row v-if="item.heading"
                :key="i"
                align="center">
          <v-col cols="6"
                  class="text-center">
            <v-subheader v-if="item.heading"
                          align="center" 
                          class="subtitle-1">
              {{ item.heading }}
            </v-subheader>
          </v-col>
          <v-col cols="6"
                  class="text-right">
            <v-btn small
                    text>
                100 EUR
              </v-btn>
          </v-col>
        </v-row>
        <v-divider v-else-if="item.divider"
                    :key="i"
                    dark
                    class="ma-auto">
          </v-divider>
          <v-list-item v-else
                      :key="i">
          <v-list-item-action>
            <v-icon>
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text font-weight-bold">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    props: {
      source: String,
      drawerRight: Boolean,
      drawer: Boolean
    },
    data: () => ({
      items: [
        { icon: 'fa-box', text: 'Artigo nr 1' },
        { icon: 'fa-box', text: 'Artigo nr 2' },
        { divider: true },
        { heading: 'Total' },
        { icon: 'fa-check-circle', text: 'Finalizar compra' },
        { icon: 'fa-dot-circle', text: 'Cancelar compra' }
      ]
    })
  }
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none
}
</style>